import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkin, logout } from 'store/actions/auth';
import {
  updateCurrentState,
  updateLoadingState,
  setSingleData,
} from 'store/actions/single';
import { addMessage } from 'store/actions/messages';
import { Form, reduxForm } from 'redux-form';
import { Box, Button, Heading } from 'grommet';
import { Checkmark, Close, Validate } from 'grommet-icons';
import './Checkin/styles.css';
import { URLBuild as handleCiviURLBuild } from 'helpers/CiviCRM';
import Map from './Checkin/Map';
import StillHere from './Checkin/StillHere';
import WelcomeHeading from './Checkin/WelcomeHeading';
import restrictionLengthList from 'helpers/restrictionLengths';
import restrictionReasonsList from 'helpers/restrictionReasons';
import * as moment from 'moment-timezone';
import ApprovedByDialog from './Checkin/ApprovedByDialog';

const handlers = {
  'click': null,
  'scroll': null,
  'touchstart': null,
  'touchend': null,
  'touchmove': null,
  'touchcancel': null,
  'keydown': null,
  'keyup': null,
};

class Checkin extends Component {

  constructor(props){
    super(props);
    this.state = {
      stillHereTimeout: null,
      stillHereOpen: false,
      approvedByOpen: false,
      checkinPressed: false,
    };
  }

  componentDidMount() {
    
    this.loadData();

    // setup events to trigger still here
    this.setupStillHereTimeout();
    const handler = e => this.setupStillHereTimeout();
    Object.keys(handlers).forEach(eventName => {
      handlers[eventName] = handler;
      window.addEventListener(eventName, handler, true);
    });
  }

  componentDidUpdate() {
    this.loadData();
  }

  componentWillUnmount() {

    if (this.state.stillHereTimeout!==null) {
      clearTimeout(this.state.stillHereTimeout);
    }

    // remove events that trigger still here
    Object.keys(handlers).forEach(eventName => {
      handlers[eventName] && window.removeEventListener(eventName, handlers[eventName], true);
    });
  }

  calculateCurrentState = () => {
    const tableState = [
      this.props.contactId,
    ].join('|');
    return tableState;
  }

  loadData = () => {
    
    const currentState = this.calculateCurrentState();
    const { state, loadingState } = this.props;
    // console.log({ currentState, state, loadingState})
    if (
      currentState === state ||
      currentState === loadingState
    ) return;

    this.props.handleUpdateLoadingState(currentState);

    const returnFields = [
      'contact_sub_type',
      // intake (on contact record FYs 19-24)
      'custom_1256', // 2018-2019 intake date/time
      'custom_1325', // 2019-2020 intake date/time
      'custom_1409', // 2020-2021 intake date/time
      'custom_1523', // 2021-2022 intake date/time
      'custom_1869', // 2022-2023 intake date/time
      'custom_2203', // 2023-2024 intake date/time      
      // restricted (on contact record before FY 26)
      'custom_367',  // Date of Restriction
      'custom_934',  // Reason for Restriction
      'custom_935',  // Length of Restriction
      'custom_370',  // Who they need to speak to
      'custom_371',  // Description
      // restricted (on activity record after FY 26)
      'custom_2431', // Hold Start or Hold End?
      'custom_2433', // Reason for Hold
      'custom_2434', // Length of Hold
      'custom_2435', // Who they need to speak to
    ];

    const intakeActivityUrl = handleCiviURLBuild('Request', 'get', {
      "activity_type_id": "304", //FY27 Youth Re-Intake
      "status_id": "Completed",
      "options":{
        "sort":"activity_date_time DESC",
        "limit": 1,
      },
      "sequential": 1,
    });
    const intakeActivityFetch = fetch(intakeActivityUrl, {
        method: "GET",
        headers: {
          Authorization: 'Bearer ' + this.props.apiKey,
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    )
    .then(response => response.json())
    .then(json => {
      if (json.is_error)
        throw new Error(json.error_message);
      return json;
    })
    .then(results => {
      const data = {
        intakeDate: null,
      };
      if (results.values.length === 0) {
        return data;
      }
      const { activity_date_time } = results.values[0];
      data.intakeDate = moment.tz(activity_date_time, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY');
      return data;
    });

    const contactUrl = handleCiviURLBuild('Contact','get',{
      'sequential': 1,
      'id': this.props.contactId,
      'return': returnFields
    });
    
    const contactFetch = fetch(contactUrl, {
      method: "GET",
      headers: {
        Authorization: 'Bearer ' + this.props.apiKey,
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    .then(response => response.json())
    .then(json => {
      if (json.is_error)
        throw new Error(json.error_message);
      return json;
    })
    .then(data => data.values[0])
    .then(data => {
      // civicrm is inconsistant in returning variables
      returnFields.forEach(field => {
        if (!(field in data))
          data[field] = '';
      });
      // console.log(data);
      const {
        // custom_1256, // 2018-2019 Intake Date
        // custom_1325, // 2019-2020 Intake Date
        // custom_1409, // 2020-2021 Intake Date
        // custom_1523, // 2021-2022 Intake Date
        // custom_1869, // 2022-2023 Intake Date
        // custom_2203, // 2023-2024 Intake Date
        custom_370,
        custom_371,
        custom_367,
        custom_934,
        custom_935,
        contact_sub_type,
      } = data;

      data.contactHold = {
        hasRestrictionContactSubType: null,
        restrictionDate: null,
        restrictionReasons: null,
        restrictionLength: null,
        restrictionSpeakTo: null,
        restrictionDescription: null,
      }
      
      // const now = moment().tz("America/Los_Angeles");
      // const year  = parseInt(now.format('Y'));
      // const month  = parseInt(now.format('M'));
      // data.intakeDate = null;
      // if ((year===2018 && month>=7) || (year===2019 && month<7)) {
      //   // 2018-2019
      //   data.intakeDate = custom_1256 ? moment.tz(custom_1256, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY') : null;
      // } else if ((year===2019 && month>=7) || (year===2020 && month<7)) {
      //   // 2019-2020
      //   data.intakeDate = custom_1325 ? moment.tz(custom_1325, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY') : null;
      // } else if ((year===2020 && month>=7) || (year===2021 && month<7)) {
      //   // 2020-2021
      //   data.intakeDate = custom_1409 ? moment.tz(custom_1409, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY') : null;
      // } else if ((year===2021 && month>=7) || (year===2022 && month<7)) {
      //   // 2021-2022
      //   data.intakeDate = custom_1523 ? moment.tz(custom_1523, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY') : null;
      // } else if ((year===2022 && month>=7) || (year===2023 && month<7)) {
      //   // 2022-2023
      //   data.intakeDate = custom_1869 ? moment.tz(custom_1869, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY') : null;
      // } else if ((year===2023 && month>=7) || (year===2024 && month<7)) {
      //   // 2023-2024
      //   data.intakeDate = custom_2203 ? moment.tz(custom_2203, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY') : null;
      // } else if ((year===2024 && month>=7) || (year===2025 && month<7) || true) {
      //   // 2024-2025
      //   // Beyond here, we use activities
      // }

      const restrictionLength = restrictionLengthList.find(length => length.value===custom_935);
      const restrictionReasons = restrictionReasonsList.filter(reason => custom_934 && custom_934.includes(reason.value));

      data.contactHold.hasRestrictionContactSubType = contact_sub_type.includes('YCH_Hold');
      data.contactHold.restrictionDate = custom_367 ?? null;
      data.contactHold.restrictionLength = restrictionLength ? restrictionLength.label : null;
      data.contactHold.restrictionReasons = restrictionReasons ? restrictionReasons.map(reason => reason.label).join(', ') : null;
      data.contactHold.restrictionSpeakTo = custom_370 ?? null;
      data.contactHold.restrictionDescription = custom_371 ?? null;

      return data;
    });

    const housingCaseUrl = handleCiviURLBuild('Request', 'cases_exist', {
      "case_type_id": [ 11, 12, 13],
      "status_id": [1, 3],
    });
    const housingCaseFetch = fetch(housingCaseUrl, {
      method: "POST",
      headers: {
        Authorization: 'Bearer ' + this.props.apiKey,
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    .then(response => response.json())
    .then(json => {
      if (json.is_error)
        throw new Error(json.error_message);
      return json;
    })
    // .then(data => data.values[0])
    .then(data => {
      const housingCasesResult = {
        hasHousingCase: data.values,
      };
      return housingCasesResult;
    });

    const holdStartActivityUrl = handleCiviURLBuild('Request', 'get', {
      "activity_type_id": "296", // Youth On-Hold Update
      "status_id": "Completed",
      "custom_2431": 1,
      "is_deleted": 0,
      "options":{
        "sort":"activity_date_time DESC",
        "limit": 1,
      },
      "sequential": 1,
    });
    const holdStartActivityFetch = fetch(holdStartActivityUrl, {
        method: "GET",
        headers: {
          Authorization: 'Bearer ' + this.props.apiKey,
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    )
    .then(response => response.json())
    .then(json => {
      if (json.is_error)
        throw new Error(json.error_message);
      return json;
    })
    .then(results => {
      const data = {
        activityHold: {
          restrictionDate: null,
          restrictionReasons: null,
          restrictionLength: null,
          restrictionSpeakTo: null,
          restrictionDescription: null,
        }
      };
      // console.log(results);
      if (results.values.length === 0) {
        return data;
      }
      // console.log(results);
      const {
        activity_date_time, // was custom_367
        details,
        // custom_2431,
        custom_2433, // was custom_934
        custom_2434, // was custom_935
        custom_2435, // was custom_370
      } = results.values[0];
      data.activityHold.restrictionDate = activity_date_time;

      const restrictionLength = restrictionLengthList.find(length => length.value===custom_2434);
      data.activityHold.restrictionLength = restrictionLength ? restrictionLength.label : null;

      const restrictionReasons = restrictionReasonsList.filter(reason => custom_2433 && custom_2433.includes(reason.value));
      data.activityHold.restrictionReasons = restrictionReasons ? restrictionReasons.map(reason => reason.label).join(', ') : null;

      data.activityHold.restrictionDescription = details ?? null;
      data.activityHold.restrictionSpeakTo = custom_2435 ?? null;
      return data;
    });

    const holdEndActivityUrl = handleCiviURLBuild('Request', 'get', {
      "activity_type_id": "296", // Youth On-Hold Update
      "status_id": "Completed",
      "custom_2431": 2,
      "is_deleted": 0,
      "options":{
        "sort":"activity_date_time DESC",
        "limit": 1,
      },
      "sequential": 1,
    });
    const holdEndActivityFetch = fetch(holdEndActivityUrl, {
        method: "GET",
        headers: {
          Authorization: 'Bearer ' + this.props.apiKey,
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    )
    .then(response => response.json())
    .then(json => {
      if (json.is_error)
        throw new Error(json.error_message);
      return json;
    })
    .then(results => {
      const data = {
        activityHoldEnd: null,
      };
      if (results.values.length === 0) {
        return data;
      }
      const { activity_date_time } = results.values[0];
      data.activityHoldEnd = activity_date_time;
      return data;
    });

    Promise.all([contactFetch, intakeActivityFetch, housingCaseFetch, holdStartActivityFetch, holdEndActivityFetch])
    .then(dataList => {
      // console.log(dataList);
      const data = dataList.reduce(function(prev, curr){
        return Object.assign({}, prev, curr);
      }, {});

      data.restriction = data.activityHold && new Date(data.activityHold.restrictionDate).getTime() > new Date(data.activityHoldEnd).getTime() ? data.activityHold : data.contactHold;

      // update list data
      this.props.handleSetSingleData(data);
      this.props.handleUpdateCurrentState(currentState);
      this.props.handleUpdateLoadingState('');
    })
    .catch(e => {
      this.props.handleMessage(e.message, 'error');
    });
    
  }

  submitForm = (values) => {
    this.toggleCheckinPressed(true);
    const { contactId, apiKey, extraContactData, handleCheckin } = this.props;
    const { hasHousingCase } = extraContactData;
    handleCheckin(contactId, apiKey, {
      custom_2444: hasHousingCase ? '1' : '0',
    });
  }

  setupStillHereTimeout = () => {

    if (this.state.stillHereTimeout!==null) {
      clearTimeout(this.state.stillHereTimeout);
    }

    const stillHereTimeout = setTimeout(() => this.toggleStillHere(), 60000); // 60 seconds
    this.setState({ stillHereTimeout });
  }

  toggleStillHere = (state=null) => {

    const stillHereOpen = state===null ? !this.state.stillHereOpen : state;
    if (!stillHereOpen) {
      this.setupStillHereTimeout();
    }
    this.setState({ stillHereOpen });
  }

  toggleApprovedByOpen = (state=null) => this.setState({approvedByOpen: state===null ? !this.state.approvedByOpen : state})

  toggleCheckinPressed = (state=null) => this.setState({checkinPressed: state===null ? !this.state.checkinPressed : state})

  render() {

    const { contact, extraContactData, handleLogout, handleSubmit, isFetching } = this.props;
    const { stillHereOpen, approvedByOpen, checkinPressed } = this.state;

    // console.log(extraContactData);
    // console.log(restriction);

    const { image_URL } = contact;
    let contactImage = null;
    const imageContainerStyles = {};
    if (image_URL) {
      const elem = document.createElement('textarea');
      elem.innerHTML = image_URL;
      contactImage = elem.value;
      imageContainerStyles.backgroundImage = `url('${contactImage}')`;
    }

    return (
      <Box className="Checkin" direction='column' flex align="center" justify="center">
        <Box className="headingbox" basis="15%">
          <WelcomeHeading />
        </Box>
        <Box className="clientbox" basis="80%" border={{ size: 'medium' }} pad="medium">
          {extraContactData==null ? 
            <Box>Loading...</Box>
          : (
            <Box direction="row" fill>
              <Box basis="40%" direction='column' fill margin={{ right: 'small' }} justify="center" align="center">
                {contactImage ? <Box className="clientimagebox" style={imageContainerStyles} fill></Box> : <Box>-- No Image --</Box> }
              </Box>
              <Box basis="60%" margin={{ left: 'small' }} pad={{ left: 'medium', top: 'medium' }}>
                <Form onSubmit={handleSubmit(this.submitForm)}>

                  {!isFetching && (extraContactData.restriction.restrictionDate || extraContactData.restriction.hasRestrictionContactSubType) && !extraContactData.hasHousingCase &&
                    <Box border="bottom" background="gold" style={{ textAlign: 'center' }}>
                      <Heading level="3" margin="small">ON HOLD</Heading>
                    </Box>
                  }
                  {!isFetching && (extraContactData.restriction.restrictionDate || extraContactData.restriction.hasRestrictionContactSubType) && extraContactData.hasHousingCase &&
                    <Box direction="row">
                      <Box basis="1/2" border="bottom" background="gold" style={{ textAlign: 'center' }}>
                        <Heading level="3" margin="small">ON HOLD</Heading>
                      </Box>
                      <Box basis="1/2" border="bottom" background="neutral-1" style={{ textAlign: 'center' }}>
                        <Heading level="3" margin="small">RESIDENTIAL</Heading>
                      </Box>
                    </Box>
                  }
                  {!isFetching && !extraContactData.restriction.restrictionDate && !extraContactData.restriction.hasRestrictionContactSubType && extraContactData.hasHousingCase &&
                    <Box border="bottom" background="neutral-1" style={{ textAlign: 'center' }}>
                      <Heading level="3" margin="small">RESIDENTIAL</Heading>
                    </Box>
                  }

                  <Box direction="row" border="bottom">
                    <Box basis="1/2" pad="xsmall"><strong>Client ID #</strong></Box>
                    <Box basis="1/2" pad="xsmall">{contact.id}</Box>
                  </Box>
                  <Box direction="row" border="bottom">
                    <Box basis="1/2" pad="xsmall"><strong>Client Name</strong></Box>
                    <Box basis="1/2" pad="xsmall">{contact.nick_name || contact.display_name}</Box>
                  </Box>
                  {/*
                    custom_1256, // 2018-2019 Intake Date
                    custom_1325, // 2019-2020 Intake Date
                    custom_1409, // 2020-2021 Intake Date
                    custom_1523, // 2021-2022 Intake Date
                    custom_1869, // 2022-2023 Intake Date
                    custom_2203, // 2023-2024 Intake Date
                    custom_367, // Date of Restriction
                    custom_934, // Reason for Restriction
                    custom_935, // Length of Restriction
                    custom_370, // Who they need to speek to
                    custom_371, // Description
                  */}
                  {!isFetching &&
                    <Box direction="row" border="bottom" background={extraContactData.intakeDate ? "transparent" : "status-critical"}>
                      <Box basis="1/2" pad="xsmall"><strong>Last Intake Date</strong></Box>
                      <Box basis="1/2" pad="xsmall">{extraContactData.intakeDate}</Box>
                    </Box>
                  }
                  {!isFetching && (extraContactData.restriction.restrictionDate || extraContactData.restriction.hasRestrictionContactSubType) ?
                    <>
                      <Box direction="row" border="bottom">
                        <Box basis="1/2" pad="xsmall"><strong>Date of Restriction</strong></Box>
                        <Box basis="1/2" pad="xsmall">{moment.tz(extraContactData.restriction.restrictionDate, 'YYYY-MM-DD HH:mm:ss', "America/Los_Angeles").format('MMMM Do, YYYY')}</Box>
                      </Box>
                      <Box direction="row" border="bottom">
                        <Box basis="1/2" pad="xsmall"><strong>Length of Restriction</strong></Box>
                        <Box basis="1/2" pad="xsmall">{extraContactData.restriction.restrictionLength}</Box>
                      </Box>
                      <Box direction="row" border="bottom">
                        <Box basis="1/2" pad="xsmall"><strong>Reason for Restriction</strong></Box>
                        <Box basis="1/2" pad="xsmall">{extraContactData.restriction.restrictionReasons}</Box>
                      </Box>
                      <Box direction="row" border="bottom">
                        <Box basis="1/2" pad="xsmall"><strong>Description of Restriction</strong></Box>
                        <Box basis="1/2" pad="xsmall">{extraContactData.restriction.restrictionDescription}</Box>
                      </Box>
                      <Box direction="row" border="bottom" background="accent-1">
                        <Box basis="1/2" pad="xsmall"><strong>Verified Approvers</strong></Box>
                        <Box basis="1/2" pad="xsmall">{extraContactData.restriction.restrictionSpeakTo}</Box>
                      </Box>
                      <Box direction="row" justify="center" align="center">
                        <Box pad={{ top: "small", bottom: "xsmall", left: "xsmall", right: "xsmall" }}>
                          <Button margin="none" label="Cancel" icon={<Close />} onClick={() => handleLogout()} />
                        </Box>
                        <Box pad={{ top: "small", bottom: "xsmall", left: "xsmall", right: "xsmall" }}>
                          {extraContactData.intakeDate ?
                            <Button margin="none" label="Approved By" color="neutral-1" icon={<Validate />} onClick={() => this.toggleApprovedByOpen(true)} primary={true} />
                          :
                            "Please see desk to complete an intake"
                          }
                        </Box>
                      </Box>
                    </>
                  :
                    <Box direction="row" justify="center" align="center">
                      <Box pad={{ top: "small", bottom: "xsmall", left: "xsmall", right: "xsmall" }}>
                        <Button margin="none" label="Cancel" icon={<Close />} onClick={() => handleLogout()} />
                      </Box>
                      <Box pad={{ top: "small", bottom: "xsmall", left: "xsmall", right: "xsmall" }}>
                        {extraContactData.intakeDate ?
                          <Button margin="none" label="Confirm" color="neutral-1" icon={<Checkmark />} type="submit" primary={true} disabled={checkinPressed}/>
                        :
                          "Please see desk to complete an intake"
                        }
                      </Box>
                    </Box>
                  }
                </Form>
                <ApprovedByDialog open={approvedByOpen} toggle={this.toggleApprovedByOpen} />
              </Box>
            </Box>
          )}
        </Box>
        <Map />
        <StillHere open={stillHereOpen} toggle={this.toggleStillHere} />
      </Box>
    );
  }
}

const mapStateToProps = (state) => {

  const { 
    auth: { contact, contactId, apiKey },
    display: { mobileMode },
    single: { extraContact },
  } = state;

  const {
    isFetching,
    data,
    loadingState,
  } = extraContact;
  
  return {
    contact,
    contactId,
    apiKey,
    mobileMode,

    isFetching,
    extraContactData: data,
    state: extraContact.state,
    loadingState,
  };
}

const mapDispatchToProps = dispatch => {

  return {
    handleLogout: () => dispatch(logout()),
    handleMessage: (message, variant=null, logout=false) => dispatch(addMessage(message, variant, logout)),
    handleUpdateCurrentState: state => dispatch(updateCurrentState('extraContact', state)),
    handleUpdateLoadingState: loadingState => dispatch(updateLoadingState('extraContact', loadingState)),
    handleSetSingleData: data => dispatch(setSingleData('extraContact', data)),
    handleCheckin: (contact_id, apiKey, extraVars = {}) => dispatch(checkin(contact_id, apiKey, extraVars)),
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'checkin',
  })(Checkin)
);
